import { styled } from '@mui/material';

const SelectInputPlaceholder = styled('span')({
  color: '#000929',
  opacity: 0.5,
  fontWeight: 400,
});

export default SelectInputPlaceholder;
